import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'

import { toast } from 'react-toastify'
import {
  GetFeeMaster,
  IMG_BASE_URL,
  RegFormAppPendingList,
  RegFormApprovedList,
  RegFormApproveReject,
  StudentFeeConcession,
} from '../../../AllAPI/AdminAPI'

const RegAppPendingList = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [concessionChecked, setConcessionChecked] = useState(false)

  const [feeTypes, setFeeTypes] = useState([])
  const [selectedFeeId, setSelectedFeeId] = useState('')
  const [feeAmount, setFeeAmount] = useState(0)
  const [concessionAmount, setConcessionAmount] = useState('')
  const [concessionRemark, setConcessionRemark] = useState('')

  const [approveLoading, setApproveLoading] = useState(false)
  const [rejectLoading, setRejectLoading] = useState(false)

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (concessionChecked) {
      fetchFeeTypes()
    }
  }, [concessionChecked])

  const fetchFeeTypes = async () => {
    try {
      const res = await axios.get(
        `${GetFeeMaster}/${storedBranchId}/${BoardingYear}`,
      )
      setFeeTypes(res.data)
    } catch (err) {
      toast.error('Failed to load fee types')
    }
  }

  useEffect(() => {
    fetchRegAppPendingList()
  }, [])

  const fetchRegAppPendingList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${RegFormAppPendingList}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        whats_no: item.wh_mobile || '-',
        tax_id: item.payment?.register_tax_id ?? '-',
        pay_date: item.payment?.register_pay_date?.split('T')[0] ?? '-',
        register_pay_mode:
          item.payment.register_pay_mode == 1
            ? 'Cash'
            : item.payment.register_pay_mode == 2
            ? 'UPI'
            : 'Online',
        payment_img: item.payment?.register_tax_image ?? '',
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search) ||
      (item.tax_id ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'whats_no' },
    { title: 'Tax ID', dataIndex: 'tax_id' },
    { title: 'Pay Date', dataIndex: 'pay_date' },
    { title: 'Pay Mode', dataIndex: 'register_pay_mode' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  const applyFeeConcession = async () => {
    const payload = {
      branch_id: Number(storedBranchId),
      fee_id: Number(selectedFeeId),
      reg_id: Number(selectedRecord.reg_id),
      concession_remark: concessionRemark,
      concession_amount: Number(concessionAmount),
      year: Number(BoardingYear),
      fee_concession_flag: 1,
    }

    return axios.post(StudentFeeConcession, payload)
  }

  const handleCancel = () => {
    setViewModalOpen(false)
    setConfirmChecked(false)
    setConcessionChecked(false)
    setConcessionAmount('')
    setConcessionRemark('')
    setSelectedFeeId(null)
    setFeeAmount(null)

    fetchRegAppPendingList()
  }

  const handleApproval = async (type) => {
    if (!selectedRecord) return

    const today = new Date().toISOString().split('T')[0]
    const approvalValue = type === 'approve' ? 2 : 3

    const approvalBody = {
      reg_id: Number(selectedRecord.reg_id),
      regPay_approval: approvalValue,
      ...(approvalValue === 2 && { regPay_approval_date: today }),
    }

    if (concessionChecked && (!selectedFeeId || !concessionAmount)) {
      toast.warning('Please fill all concession details')
      return
    }

    try {
      //  set loader based on button type
      type === 'approve' ? setApproveLoading(true) : setRejectLoading(true)

      //  1. First approve/reject registration
      const res = await axios.put(RegFormApproveReject, approvalBody)

      if (res.data == 'APPROVED') {
        toast.success('Application Approved Successfully')
        return
      }
      if (res.data == 'REJECTED') {
        toast.success('Approval rejected !')
        return
      }
      else if (res.data == 'NOTFOUND') {
        toast.warn('Approval data not found !')
      }
      else if (res.data !== 'APPROVED') {
        toast.error('Approval failed !')
        return
      }

      //  2. If approved + concession checked → call concession API
      if (type === 'approve' && concessionChecked) {
        if (!selectedFeeId || !concessionAmount) {
          toast.warning('Please fill concession details')
          return
        }

        await applyFeeConcession()
      }

      

      //  Reset & refresh
      handleCancel()
    } catch (error) {
      toast.error('Something went wrong!')
    } finally {
      // 🔹 stop loader
      setApproveLoading(false)
      setRejectLoading(false)
    }
  }

  // useEffect(() => {
  //   if (concessionChecked && feeTypes.length >= 2) {
  //     const secondFee = feeTypes[1]

  //     setSelectedFeeId(secondFee.fee_id)
  //     setFeeAmount(secondFee?.feeAmounts?.[0]?.fee_amount || 0)
  //   }
  // }, [concessionChecked, feeTypes])

  useEffect(() => {
    if (concessionChecked && feeTypes.length > 0) {
      const hostelFee = feeTypes.find((fee) => fee.fee_name === 'Hostel Fee')

      if (hostelFee) {
        setSelectedFeeId(hostelFee.fee_id)

        const amount =
          hostelFee?.feeAmounts?.length > 0
            ? hostelFee.feeAmounts[0].fee_amount
            : 0

        setFeeAmount(amount)
      }
    }
  }, [concessionChecked, feeTypes])

  const handleFeeChange = (e) => {
    const feeId = Number(e.target.value)
    setSelectedFeeId(feeId)

    const selectedFee = feeTypes.find((f) => f.fee_id === feeId)

    const amount =
      selectedFee?.feeAmounts?.length > 0
        ? selectedFee.feeAmounts[0].fee_amount
        : 0

    setFeeAmount(amount)
  }

  const docs = data.documents || {}
  //================================================
  // const downloadFile = (fileUrl, fileName) => {
  //   const link = document.createElement('a')
  //   link.href = fileUrl
  //   link.download = fileName
  //   document.body.appendChild(link)
  //   link.click()
  //   document.body.removeChild(link)
  // }

  const downloadFile = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl)
      const blob = await response.blob()

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.download = fileName
      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Download failed', error)
    }
  }

  const renderDocument = (filePath, title) => {
    if (!filePath) return null

    const fileUrl = `${IMG_BASE_URL}${filePath}`
    const isPDF = filePath.toLowerCase().endsWith('.pdf')

    return (
      <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3 text-center">
        <p className="fw-semibold mb-1">{title}</p>

        {isPDF ? (
          <iframe
            src={fileUrl}
            title={title}
            style={{
              width: '100%',
              height: '300px',
              border: '1px solid #ddd',
              borderRadius: '6px',
            }}
          />
        ) : (
          <img
            src={fileUrl}
            alt={title}
            className="img-fluid rounded border"
            style={{
              width: '100%',
              height: '300px',
              objectFit: 'contain',
            }}
          />
        )}

        <Button
          size="small"
          type="primary"
          style={{ marginTop: '8px' }}
          onClick={() => downloadFile(fileUrl, title)}
        >
          Download
        </Button>
      </div>
    )
  }

  // =======CSS==========
  const labelCss = {
    fontWeight: '600',
  }
  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Registration Approval Pending List</h2>
          </div>

          <div className="search-bar">
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => {
          setViewModalOpen(false)
          handleCancel()
        }}
        footer={null}
        width={980}
      >
        {selectedRecord && (
          <div className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Registration Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              {/* ========= PERSONAL INFORMATION ========== */}
              <h6 style={titleText}>- Personal Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12 col-md-3">
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.s_pic}`}
                      alt="Profile Picture"
                      className="rounded-circle img-fluid rounded border"
                      style={{
                        width: '160px',
                        height: '160px',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-9">
                    <div className="row">
                      <div className="col-md-12 py-1">
                        <span style={labelCss}>Full Name:</span>
                        <br />
                        <span
                          style={{
                            backgroundColor: '#f8ff90',
                            padding: '2px 10px',
                            fontSize: '16px',
                          }}
                        >
                          {selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                          {selectedRecord.s_lname}
                        </span>
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Mobile:</span>
                        <br /> {selectedRecord.mobile}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>WhatsApp No:</span>
                        <br /> {selectedRecord.wh_mobile || '-'}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Email:</span>
                        <br /> {selectedRecord.email}
                      </div>
                      <div className="col-md-8 py-1">
                        <span style={labelCss}>Address:</span>
                        <br /> {selectedRecord.address},{' '}
                        {selectedRecord.village}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ========= ACADEMIC INFORMATION ========== */}
              <h6 style={titleText}>- Academic Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>
                      Name of School / College Last Attended:
                    </span>
                    <br /> {selectedRecord.last_attended_clg_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>
                      Highest Qualification Obtained:
                    </span>
                    <br /> {selectedRecord.highest_qualification}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Specific Degree:</span>
                    <br /> {selectedRecord.specific_degree}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Aggregate Percentage (%):</span>
                    <br /> {selectedRecord.aggre_percentage}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Month & Year of Passing:</span>
                    <br /> {selectedRecord.month_year_of_passing}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>
                      Name of Institution Currently Enrolled In:
                    </span>
                    <br /> {selectedRecord.curr_yr_clg_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Course / Program Name:</span>
                    <br /> {selectedRecord.course_name}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Total Course Duration:</span>
                    <br /> {selectedRecord.total_course_duration}
                  </div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Remaining Duration of Course:</span>
                    <br /> {selectedRecord.remaining_course_duration}
                  </div>
                </div>
              </div>

              {/* ========= FAMILY INFORMATION ========== */}
              <h6 style={titleText}>- Family Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                {/* =======FATHER INFO======= */}
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Father Name:</span>
                    <br />
                    {selectedRecord.father_fname} {selectedRecord.father_mname}{' '}
                    {selectedRecord.father_lname}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Father Mobile No.:</span>
                    <br /> {selectedRecord.father_mob}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Father Age:</span>
                    <br /> {selectedRecord.father_mob}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Father Occupation:</span>
                    <br /> {selectedRecord.father_occ}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Total Family Members:</span>
                    <br /> {selectedRecord.total_family_mamber}
                  </div>
                </div>
                {/* =======MOTHER INFO======= */}
                <div className="row">
                  <div
                    className="col-12 m-0 p-0 mb-3"
                    style={{ borderTop: '1px solid #d2d2d2ff' }}
                  ></div>

                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Mother Name:</span>
                    <br />
                    {selectedRecord.mother_fname} {selectedRecord.mother_mname}{' '}
                    {selectedRecord.mother_lname}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Mother Mobile No.:</span>
                    <br /> {selectedRecord.mother_mob}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Mother Age:</span>
                    <br /> {selectedRecord.mother_mob}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Mother Occupation:</span>
                    <br /> {selectedRecord.mother_occ}
                  </div>
                </div>
                {/* =======EMERGENCY INFO======= */}
                <div className="row">
                  <div
                    className="col-12 m-0 p-0 mb-3"
                    style={{ borderTop: '1px solid #d2d2d2ff' }}
                  ></div>

                  <div className="col-md-6 col-lg-4 mb-3">
                    <span style={labelCss}>Emergency Contact Name:</span>
                    <br />
                    {selectedRecord.emergency_name}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Emergency Mobile No.:</span>
                    <br /> {selectedRecord.emergency_contact}
                  </div>
                </div>
              </div>

              {/* ========= PAYMENT INFORMATION ========== */}
              <h6 style={titleText}>- Payment Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Tax ID:</span>
                    <br /> {selectedRecord.payment?.register_tax_id}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Payment Date:</span>
                    <br />
                    {selectedRecord.payment?.register_pay_date?.split('T')[0]}
                  </div>
                  <div className="col-md-4 mb-3">
                    <span style={labelCss}>Amount:</span>
                    <br /> ₹{selectedRecord.payment?.register_pay_amount}
                  </div>
                </div>
              </div>

              {/* ========= UPLOADED DOCUMENTS ========== */}
              <>
                <h6 style={titleText}>- Uploaded Documents :</h6>

                {/* <div className="row text-center">
                  <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                    <p className="fw-semibold mb-1">Aadhar Card</p>
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.s_aadhar}`}
                      alt="Aadhar Card"
                      className="img-fluid rounded border"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                    <p className="fw-semibold mb-1">Registration Fee Receipt</p>
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.payment.register_tax_image}`}
                      alt="Reg. Fee Receipt"
                      className="img-fluid rounded border"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                    <p className="fw-semibold mb-1">Caste Income Certificate</p>
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.cast_income_cert}`}
                      alt="Caste Income Certificate"
                      className="img-fluid rounded border"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                    <p className="fw-semibold mb-1">Recommendation Letter</p>
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.recommendation_letter}`}
                      alt="Recommendation Letter"
                      className="img-fluid rounded border"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3">
                    <p className="fw-semibold mb-1">
                      College Admission Receipt
                    </p>
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.clg_add_receipt}`}
                      alt="College Admission Receipt"
                      className="img-fluid rounded border"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>
                </div> */}

                <div className="row text-center">
                  {renderDocument(
                    selectedRecord.documents.s_aadhar,
                    'Aadhar Card',
                  )}

                  {renderDocument(
                    selectedRecord.payment.register_tax_image,
                    'Registration Fee Receipt',
                  )}

                  {renderDocument(
                    selectedRecord.documents.cast_income_cert,
                    'Caste Income Certificate',
                  )}

                  {renderDocument(
                    selectedRecord.documents.recommendation_letter,
                    'Recommendation Letter',
                  )}

                  {renderDocument(
                    selectedRecord.documents.clg_add_receipt,
                    'College Admission Receipt',
                  )}
                </div>
              </>

              <div className="d-flex align-items-center mb-3 mt-5">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  style={{ border: '1px solid black' }}
                  checked={concessionChecked}
                  onChange={(e) => setConcessionChecked(e.target.checked)}
                />
                <label style={{ fontSize: '15px', fontWeight: '500' }}>
                  Apply fee concession for this student
                </label>
              </div>

              {concessionChecked && (
                <div className="border rounded p-3 mb-3 bg-light">
                  <h6 style={{ fontWeight: 600, color: '#235784' }}>
                    Fee Concession Details
                  </h6>

                  <div className="row m-0">
                    {/* Fee Type */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-semibold">Fee Type</label>
                      <select
                        className="form-select"
                        // disabled
                        value={selectedFeeId}
                        onChange={handleFeeChange}
                      >
                        <option value="">Select Fee Type</option>
                        {feeTypes.map((fee) => (
                          <option key={fee.fee_id} value={fee.fee_id}>
                            {fee.fee_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Fee Amount (Auto Filled) */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-semibold">
                        Fee Amount
                      </label>
                      <Input
                        value={feeAmount}
                        readOnly
                        style={{ backgroundColor: '#e6e6e6ff' }}
                      />
                    </div>

                    {/* Concession Amount */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-semibold">
                        Concession Amount
                      </label>

                      <Input
                        value={concessionAmount}
                        placeholder="Enter concession amount"
                        maxLength={7}
                        onChange={(e) => {
                          // ✅ allow only numbers
                          const value = e.target.value.replace(/[^0-9]/g, '')
                          setConcessionAmount(value)
                        }}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault()
                          }
                        }}
                      />
                    </div>

                    {/* Remark */}
                    <div className="col-12 mb-3">
                      <label className="form-label fw-semibold">Remark</label>
                      <Input.TextArea
                        rows={2}
                        value={concessionRemark}
                        onChange={(e) => setConcessionRemark(e.target.value)}
                        placeholder="Enter remark"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/**-----------APPROVE/REJECT SECTION-----------------*/}

            <div className="mt-4 p-3">
              {/* Confirm Checkbox */}
              <div className="d-flex align-items-center mb-3">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  style={{ border: '1px solid black' }}
                  checked={confirmChecked}
                  onChange={(e) => setConfirmChecked(e.target.checked)}
                />
                <label style={{ fontSize: '15px', fontWeight: '500' }}>
                  I confirm all details are checked and verified
                </label>
              </div>

              {/* Buttons */}
              <div className="d-flex gap-3 mt-3">
                <Button
                  type="primary"
                  disabled={!confirmChecked}
                  loading={approveLoading}
                  onClick={() => handleApproval('approve')}
                >
                  Approve
                </Button>

                <Button
                  danger
                  disabled={!confirmChecked}
                  loading={rejectLoading}
                  onClick={() => handleApproval('reject')}
                >
                  Reject
                </Button>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default RegAppPendingList
